var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('navbar'),_c('v-container',{class:_vm.padding,attrs:{"fluid":""}},[_c('router-view',{attrs:{"id":"content"}})],1),(true)?_c('footer-app'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }